import * as React from "react";
import {
  AccessorFn,
  ColumnHelper,
  DeepKeys,
  DisplayColumnDef,
  RowData
} from "@tanstack/react-table";

import { Text } from "src/library/components/Text";
import {
  ISupportTicket,
  SupportTicketStatus
} from "src/modules/support/api/support.api";
import SupportTicketStatusStyled, { statusTextSwitch } from "src/modules/support/components/SupportTicketStatus";
import {
  IRole,
  RoleType
} from "src/core/shared/api/roles.api";

/**
 * This function returns a reusable formated column definition for support ticket status data to be used in Tanstack tables
 *
 * @param columnHelper
 * @param accessor
 * @param column
 * @returns column definition for order status data
 */
export const supportTicketStatusColumn = <TData extends RowData, TAccessor = AccessorFn<TData> | DeepKeys<TData>>(
  columnHelper: ColumnHelper<TData>,
  accessor: TAccessor,
  currentRole: IRole | null
) => {
  return columnHelper.accessor(accessor as DeepKeys<TData>, {
    id: accessor,
    filterType: "string",
    header: "Status",
    cell: info => {
      const ticket = info.row.original as ISupportTicket;

      return (
        <SupportTicketStatusStyled
          status={ticket.status}
        />
      );
    },
    enableResizing: true,
    minSize: 100,
    meta: {
      filter: {
        filterType: "select",
        options: statusOptions(currentRole?.type)
      }
    }
  } as DisplayColumnDef<TData>);
};

const statusOptions = (currentRoleType?: RoleType): Array<{text: string, value: string}> => { //all_resolved to be picked up by onFetch function
  return [
    {
      text: statusTextSwitch(SupportTicketStatus.New, currentRoleType),
      value: SupportTicketStatus.New
    },
    {
      text: statusTextSwitch(SupportTicketStatus.PendingAdminResponse, currentRoleType),
      value: SupportTicketStatus.PendingAdminResponse
    },
    {
      text: statusTextSwitch(SupportTicketStatus.PendingCustomerResponse, currentRoleType),
      value: SupportTicketStatus.PendingCustomerResponse
    },
    {
      text: "Resolved",
      value: "all_resolved" //all_resolved to be picked up by onFetch function
    }
  ];
};